// extracted by css-extract-rspack-plugin
export default {"tab-drag-n-drop":"tab-drag-n-drop-zfVtDH","tabDragNDrop":"tab-drag-n-drop-zfVtDH"};